BX.addCustomEvent('onAjaxSuccess', function () {
	console.log(1);
	if (document.querySelector('.articles-list__filter-items')) {
		window.k1ScriptDefault.loadPictures([...document.querySelectorAll('.def-load-picture')]);
		window.k1Base.fillFilter()
	}

	if (document.querySelector('.news-page')) {
		window.k1ScriptDefault.loadPictures([...document.querySelectorAll('.def-load-picture')]);
	}

	if (document.querySelector('.good-element')) {
		window.k1ScriptCatalog.prepareSKU([...document.querySelectorAll('.k1-sku-block-js')]);
		window.k1ScriptCatalog.hideElementDescription();
		// window.k1ScriptCatalog.init();
		window.k1ScriptDefault.loadPictures([...document.querySelectorAll('.def-load-picture')]);
		window.k1Sliders.init();
	}

	if (document.querySelector('.section-goods')) {
		window.k1ScriptCatalog.prepareSKU([...document.querySelectorAll('.k1-sku-block-js')]);
		window.k1ScriptCatalog.setLastChild();
		window.k1ScriptDefault.loadPictures([...document.querySelectorAll('.def-load-picture')]);
		window.k1FilterGoods.setMaxHeightSizesBoxes();
		window.k1FilterGoods.setMinHeightSizesBoxes();
		window.dremVars.openedSizesFilter = false;
		window.k1FilterGoods.checkOpenSize();
	}

	if (document.querySelector('.order-cart')) {
		setTimeout(() => {
			// window.k1Order.init()
		}, 100);
		window.k1Order.dropCommentBlock();
		window.k1ValidateForm.init();
	}


});